import {
  type MemberConsentsListQuerySchema,
  type Paginated,
  type UserConsent,
} from '@aysar/contracts';
import { createApi } from '@reduxjs/toolkit/query/react';
import type { z } from 'zod';

import { baseQueryWithAuth } from '@/shared/store/middleware/base-query-with-auth/base-query-with-auth';

type MemberConsentsParams = z.input<typeof MemberConsentsListQuerySchema>;

/**
 * One member's consent history, for the member detail (P7b). In `shared/`
 * because Members draws it and Legal owns it, and neither may import the other
 * (W6). Refetched on every mount: consents are member-written and append-only,
 * so no admin mutation could invalidate them.
 */
export const memberConsentsLookupApi = createApi({
  reducerPath: 'memberConsentsLookupApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['MemberConsents'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    memberConsents: builder.query<Paginated<UserConsent>, MemberConsentsParams>({
      query: (params) => ({ url: '/admin/legal/consents', method: 'GET', params }),
      providesTags: (_r, _e, { userId }) => [{ type: 'MemberConsents' as const, id: userId }],
    }),
  }),
});

export const { useMemberConsentsQuery } = memberConsentsLookupApi;
